import { GraduationCap, Plane, Heart, Coffee } from 'lucide-react';

/**
 * The 4 Identity Board categories. Single source of truth for icon/color/label
 * mapping used across MatchDetail (score breakdown + shared traits) and
 * board Overview (block grid).
 */
export const CATEGORY_CONFIG = [
  { key: 'core', label: 'Core', icon: GraduationCap, color: 'primary' },
  { key: 'journey', label: 'Journey', icon: Plane, color: 'accent' },
  { key: 'interests', label: 'Interests', icon: Heart, color: 'twins' },
  { key: 'lifestyle', label: 'Lifestyle', icon: Coffee, color: 'strong' },
] as const;

export type CategoryKey = (typeof CATEGORY_CONFIG)[number]['key'];
